module.exports = __webpack_public_path__ + "img/TZS09583.dea3513c.jpeg";